import React from 'react';

import { DroneHarmonyIntegrationItem, IntegrationStatus } from '../../state/integrations-state';
import { ActiveView } from './active-view';
import { SetupView } from './setup-view';

type Props = {
  item: DroneHarmonyIntegrationItem;
};

const DroneHarmonyIntegration = (props: Props) => {
  if (props.item.status === IntegrationStatus.Active && props.item.authentication.isSsoLinked) {
    return <ActiveView item={props.item} />;
  }

  return <SetupView item={props.item} />;
};

export { DroneHarmonyIntegration };
